import {
  AxiosMethod,
  defaultAxiosOptions,
  serviceEndpoints,
} from '../../../constants';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { ResponseValuesOverride } from '../../../models/response-values-override';

export function useRemoveAuthTokenRequest<T>(): [
  ResponseValuesOverride<T>,
  () => AxiosPromise<T>,
] {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Post,
    url: serviceEndpoints.signOutApi(),
  };

  const [responseValues, execute] = useAxios<T>(config, {
    ...defaultAxiosOptions,
  });

  return [responseValues, (): AxiosPromise<T> => execute(config)];
}
